import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/pages/header/layout.vue'
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

let routes = [
  {
    path:'/',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/ecshop',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/ecshop/',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php/contacts',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/personnel',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/redmine/projects/nanjing/search',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/redmine/news',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/claimcase',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php/favicon.ico',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/redmine/projects',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/article.php',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php/component/k2/item/25-2019-08-14-07-42-36',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php/team',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/redmine/projects/no5/issues.atom',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/index.php/download',
    hidden:true,
    redirect:{path:'/home'}
  },
  {
    path:'/home',
    name:'首页',
    component:() => import ('@/pages/home.vue')

  },
  
  {
    path:'/',
    hidden:true,
    component:layout,
    children:[
      
      {
        path:'/aboutUs',
        name:'关于利真',
        component:() => import ('@/pages/aboutUs.vue')

      },
      {
        path:'/news',
        name:'新闻动态',
        component:() => import ('@/pages/news.vue')

      },
      {
        path:'/job',
        name:'社会招聘',
        component:() => import ('@/pages/job.vue')

      },
      {
        path:'/trip',
        name:'荔枝出行',
        component:() => import ('@/pages/trip.vue')

      },
      {
        path:'/contact',
        name:'联系我们',
        component:() => import ('@/pages/contact.vue')

      },
      {
        path:'/warranty',
        name:'利真延保',
        component:() => import ('@/pages/warranty.vue')

      },
      {
        path:'/newsDetail/:infoId',
        name:'新闻详情',
        component:() => import ('@/pages/newsDetail.vue')

      }
    ]
  },
  
  
]
const RouterConfig = {
  mode: 'history',
  routes
}
const router = new Router(RouterConfig)

export default router




// WEBPACK FOOTER //
// ./src/router/index.js